import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import SEOArticlePage from "@/pages/seo-article/page";
import KakobuyGuidePage from "@/pages/kakobuy-guide/page";
import AgentComparisonPage from "@/pages/agent-comparison/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/what-is-cssbuy-spreadsheet",
    element: <SEOArticlePage />,
  },
  {
    path: "/kakobuy-spreadsheet-guide",
    element: <KakobuyGuidePage />,
  },
  {
    path: "/agent-comparison-2026",
    element: <AgentComparisonPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;